import React from 'react';
import { DatePicker, DatePickerProps } from '@atlaskit/datetime-picker';
import './date-picker-highlighted.scss';

type HighlightedDatePickerProps = DatePickerProps & {
  datesToHighlight?: string[];
};

const HighlightedDatePicker: React.FC<HighlightedDatePickerProps> = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { datesToHighlight = [], ...rest } = props;
  return (
    <div className="date-picker-container">
      <DatePicker {...rest} />
    </div>
  );
};

export default HighlightedDatePicker;
